export default __webpack_public_path__ + "988a1a31c4f20d1a34a90362c2ad8cdc.ttf";